import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  express?: boolean;
};

const StripeTableMockUp = (props: Props) => {
  const { t } = useTranslation();
  const { express } = props;
  if (express) {
    return (
      <>
        <div className="flex w-full mt-5 md:text-sm text-xs overflow-auto">
          <div className="flex flex-col w-full">
            <div className="border p-1 w-full truncate text-white">.</div>
            <div className="border p-1 w-full truncate">
              {t("general.charges")}
            </div>
            <div className="border p-1 w-full truncate">
              {t("general.refunds")}
            </div>
            <div className="border p-1 w-full truncate">
              {t("general.adjustments")}
            </div>
          </div>
          <div>
            <div className="flex w-full">
              <div className="w-full">
                <div className="border p-1 w-full truncate text-right">
                  {t("orders.amount")}
                </div>
                <div className="border p-1 w-full truncate text-right">
                  10.00€
                </div>
                <div className="border p-1 w-full truncate text-right">
                  0.00€
                </div>
                <div className="border p-1 w-full truncate text-right">
                  0.00€
                </div>
              </div>
              <div className="w-full">
                <div className="border p-1 w-full truncate text-right">
                  {t("order.fee")}
                </div>
                <div className="border p-1 w-full truncate text-right">
                  +0.51€
                </div>
                <div className="border p-1 w-full truncate text-right">
                  0.00€
                </div>
                <div className="border p-1 w-full truncate text-right">
                  0.00€
                </div>
                <div className="border p-1 w-full truncate text-right">
                  {t("general.transfers")}
                </div>
              </div>
              <div className="w-full">
                <div className="border p-1 w-full truncate text-right">
                  {t("resv.total")}
                </div>
                <div className="border p-1 w-full truncate text-right">
                  10.51€
                </div>
                <div className="border p-1 w-full truncate text-right">
                  0.00€
                </div>
                <div className="border p-1 w-full truncate text-right">
                  0.00€
                </div>
                <div className="border p-1 w-full truncate text-right">
                  10.00€
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="flex w-full mt-5 md:text-sm text-xs overflow-auto">
        <div className="flex flex-col w-full">
          <div className="border p-1 w-full truncate text-white">.</div>
          <div className="border p-1 w-full truncate">
            {t("general.charges")}
          </div>
          <div className="border p-1 w-full truncate">
            {t("general.refunds")}
          </div>
          <div className="border p-1 w-full truncate">
            {t("general.adjustments")}
          </div>
        </div>
        <div>
          <div className="flex w-full">
            <div className="w-full">
              <div className="border p-1 w-full truncate text-right">
                {t("orders.amount")}
              </div>
              <div className="border p-1 w-full truncate text-right">
                10.00€
              </div>
              <div className="border p-1 w-full truncate text-right">0</div>
              <div className="border p-1 w-full truncate text-right">0</div>
            </div>
            <div className="w-full">
              <div className="border p-1 w-full truncate text-right">
                {t("stipe.processingFees")}
              </div>
              <div className="border p-1 w-full truncate text-right">
                -0.40€
              </div>
              <div className="border p-1 w-full truncate text-right">0.00€</div>
              <div className="border p-1 w-full truncate text-right">0.00€</div>
            </div>
            <div className="w-full">
              <div className="border p-1 w-full truncate text-right">
                {t("general.applicationFee")}
              </div>
              <div className="border p-1 w-full truncate text-right">
                -0.20€
              </div>
              <div className="border p-1 w-full truncate text-right">0.00€</div>
              <div className="border p-1 w-full truncate text-right">0.00€</div>
              <div className="border p-1 w-full truncate text-right">
                {t("general.transfers")}
              </div>
            </div>
            <div className="w-full">
              <div className="border p-1 w-full truncate text-right">
                {t("apartment.tax")}
              </div>
              <div className="border p-1 w-full truncate text-right">
                -0.09€
              </div>
              <div className="border p-1 w-full truncate text-right">0.00€</div>
              <div className="border p-1 w-full truncate text-right">0.00€</div>
              <div className="border p-1 w-full truncate text-right">9.31€</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StripeTableMockUp;
